module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "color": "transparent",
      "fixed-tabs": "",
      "slider-color": "primary"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('v-tab', {
      key: tab.key,
      attrs: {
        "href": '#tab-' + tab.key
      }
    }, [_vm._v("\n      " + _vm._s(tab.name) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.addDeviceDialog),
      callback: function($$v) {
        _vm.addDeviceDialog = $$v
      },
      expression: "addDeviceDialog"
    }
  }, [_c('v-card', [_c('v-container', {
    staticClass: "text-xs-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "label": "Device Type",
      "items": _vm.filteredDeviceTypes,
      "item-text": "name",
      "return-object": "",
      "item-value": "id"
    },
    model: {
      value: (_vm.selectedDeviceType),
      callback: function($$v) {
        _vm.selectedDeviceType = $$v
      },
      expression: "selectedDeviceType"
    }
  })], 1), _vm._v(" "), (_vm.selectedDeviceType !== null) ? [_vm._l((_vm.selectedDeviceType.extras), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(['text', 'number'].indexOf(item.type) !== -1) ? _c('v-text-field', {
      staticClass: "ml-2",
      attrs: {
        "outline": "",
        "type": item.type === 'number' ? 'number' : 'text',
        "step": item.type === 'number' ? item.step : '',
        "label": item.name
      },
      model: {
        value: (_vm.newDevice[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.newDevice, item.name, $$v)
        },
        expression: "newDevice[item.name]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'uid') ? _c('v-text-field', {
      staticClass: "ml-2",
      attrs: {
        "outline": "",
        "readonly": _vm.editID !== -1,
        "rules": [function (v) { return _vm.deviceIDs.indexOf(v) === -1 || v === _vm.editID || 'Device already in system'; }],
        "label": item.name
      },
      model: {
        value: (_vm.newDevice[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.newDevice, item.name, $$v)
        },
        expression: "newDevice[item.name]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'sim') ? _c('v-autocomplete', {
      staticClass: "ml-2",
      attrs: {
        "outline": "",
        "clearable": "",
        "item-text": "ICCID",
        "item-value": "ICCID",
        "rules": [function (v) { return _vm.filteredSIMS.indexOf(v) === -1 || v === _vm.editSIM || 'SIM already allocated to another device'; }],
        "items": _vm.SIMS,
        "label": item.name
      },
      model: {
        value: (_vm.newDevice[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.newDevice, item.name, $$v)
        },
        expression: "newDevice[item.name]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'choice') ? _c('v-select', {
      staticClass: "ml-2",
      attrs: {
        "outline": "",
        "label": item.name,
        "items": item.options,
        "value": item.default,
        "clearable": ""
      },
      model: {
        value: (_vm.newDevice[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.newDevice, item.name, $$v)
        },
        expression: "newDevice[item.name]"
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "clearable": "",
      "label": "Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "key"
    },
    model: {
      value: (_vm.newDevice.customer),
      callback: function($$v) {
        _vm.$set(_vm.newDevice, "customer", $$v)
      },
      expression: "newDevice.customer"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "clearable": "",
      "label": "Vehicle Reg",
      "items": _vm.filteredVehicles,
      "item-text": "VehicleReg",
      "item-value": "key"
    },
    model: {
      value: (_vm.newDevice.vehicle),
      callback: function($$v) {
        _vm.$set(_vm.newDevice, "vehicle", $$v)
      },
      expression: "newDevice.vehicle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "clearable": "",
      "label": "Product",
      "items": _vm.filteredProducts,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.newDevice.product),
      callback: function($$v) {
        _vm.$set(_vm.newDevice, "product", $$v)
      },
      expression: "newDevice.product"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    staticClass: "ml-2",
    attrs: {
      "outline": "",
      "label": "Stock Location",
      "items": _vm.stockChoices
    },
    model: {
      value: (_vm.newDevice.stockLocation),
      callback: function($$v) {
        _vm.$set(_vm.newDevice, "stockLocation", $$v)
      },
      expression: "newDevice.stockLocation"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.adding
    },
    domProps: {
      "innerHTML": _vm._s(_vm.editID === -1 ? 'Add Device' : 'Edit Device')
    },
    on: {
      "click": _vm.addDevice
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.bulkAddDeviceDialog),
      callback: function($$v) {
        _vm.bulkAddDeviceDialog = $$v
      },
      expression: "bulkAddDeviceDialog"
    }
  }, [_c('v-card', [_c('v-container', {
    staticClass: "text-xs-center"
  }, [_c('v-select', {
    attrs: {
      "label": "Device Type",
      "items": _vm.filteredDeviceTypes,
      "item-text": "name",
      "return-object": "",
      "item-value": "id",
      "disabled": _vm.exported
    },
    model: {
      value: (_vm.selectedDeviceType),
      callback: function($$v) {
        _vm.selectedDeviceType = $$v
      },
      expression: "selectedDeviceType"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "clearable": "",
      "label": "Product",
      "items": _vm.filteredProducts,
      "item-text": "name",
      "item-value": "id",
      "disabled": _vm.exported
    },
    model: {
      value: (_vm.exportProduct),
      callback: function($$v) {
        _vm.exportProduct = $$v
      },
      expression: "exportProduct"
    }
  }), _vm._v(" "), (_vm.selectedDeviceType) ? [(_vm.exported) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.exported = false;
        _vm.excelInput = '';
        _vm.dataProcessed = false
      }
    }
  }, [_vm._v("\n            Reset\n          ")]) : _vm._e(), _vm._v(" "), (_vm.exported) ? [_c('div', [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.exported),
      callback: function($$v) {
        _vm.exported = $$v
      },
      expression: "exported"
    }
  }, [_vm._v("\n                Data Exported To Clipboard Successfully. Please make any alterations and paste data into below textbox to process.\n              ")])], 1)] : _vm._e(), _vm._v(" "), (!_vm.exported) ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.createExportTemplate
    }
  }, [_vm._v("Export Template")]) : _vm._e(), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Warning - Only the first 500 rows will be processed",
      "id": "excelInput"
    },
    model: {
      value: (_vm.excelInput),
      callback: function($$v) {
        _vm.excelInput = $$v
      },
      expression: "excelInput"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.importFromTemplate
    }
  }, [_vm._v("Import")])] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab-item', {
    key: "devices",
    attrs: {
      "value": "tab-devices"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 10,
      "rotate": 360,
      "value": (_vm.stockTotal / _vm.filteredDevices.length) * 100,
      "color": "primary"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.stockTotal) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Unallocated Stock")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-2 ma-1 text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 70,
      "width": 10,
      "rotate": 360,
      "value": ((_vm.filteredDevices.length - _vm.stockTotal) / _vm.filteredDevices.length) * 100,
      "color": "green"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.filteredDevices.length - _vm.stockTotal) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("Allocated Devices")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredDeviceTypes,
      "label": "Filter Device Type",
      "item-text": "name",
      "item-value": "id",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.deviceTypeFilter),
      callback: function($$v) {
        _vm.deviceTypeFilter = $$v
      },
      expression: "deviceTypeFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredVehicles,
      "label": "Filter Vehicle",
      "item-text": "VehicleReg",
      "item-value": "key",
      "multiple": "",
      "hide-detaile": "",
      "chips": "",
      "deletable-chips": "",
      "clearable": "",
      "solo": ""
    },
    model: {
      value: (_vm.vehicleFilter),
      callback: function($$v) {
        _vm.vehicleFilter = $$v
      },
      expression: "vehicleFilter"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "clearable": "",
      "label": "Select Customer",
      "items": _vm.customers,
      "item-text": "name",
      "item-value": "key",
      "multiple": "",
      "chips": "",
      "dense": "",
      "deletable-chips": "",
      "solo": ""
    },
    model: {
      value: (_vm.selectedCustomer),
      callback: function($$v) {
        _vm.selectedCustomer = $$v
      },
      expression: "selectedCustomer"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "dismissible": ""
    },
    model: {
      value: (_vm.exportAlert),
      callback: function($$v) {
        _vm.exportAlert = $$v
      },
      expression: "exportAlert"
    }
  }, [_vm._v("\n                  Data copied to clipboard\n                ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.newDeviceDialog
    }
  }, [_vm._v("\n                    Add Devices\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.bulkAddDeviceDialog = true
      }
    }
  }, [_vm._v("\n                    Bulk Import\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("Export")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.deviceSearch),
      callback: function($$v) {
        _vm.deviceSearch = $$v
      },
      expression: "deviceSearch"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.filteredDevices) ? _c('v-data-table', {
    attrs: {
      "rows-per-page-items": [5, 10, 25, 50, 100, 200, {
        'text': '$vuetify.dataIterator.rowsPerPageAll',
        'value': -1
      }],
      "loading": _vm.devicesLoading,
      "search": _vm.deviceSearch,
      "items": _vm.filteredDevices,
      "headers": _vm.deviceColumns
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.formattedType))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.IMEI))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.formattedCustomer))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.formattedVehicle))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.formattedProduct))]), _vm._v(" "), _c('td', {
          class: props.item.SIM === null || props.item.SIM.length < 19 ? 'error' : '',
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.SIM))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.getDeviceHistory(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.stockLocation))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "flat": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openTesting(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-cloud-check")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "flat": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.editDevice(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-layout', {
          attrs: {
            "justify-center": ""
          }
        }, [(_vm.installationJob) ? _c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('ul', {
          staticStyle: {
            "list-style-type": "none"
          }
        }, [_c('li', [_vm._v("Contract Start: " + _vm._s(_vm.installationJob.CompletedDate))]), _vm._v(" "), _c('li', [_vm._v("Contract Term: " + _vm._s(_vm.installationJob.contractDetails.length) + " " + _vm._s(_vm.installationJob.contractDetails.period))]), _vm._v(" "), _c('li', [_vm._v("Contract Expiry: " + _vm._s(_vm.installationJob.contractDetails.expiry))]), _vm._v(" "), _c('li', [_vm._v("Warranty Period: " + _vm._s(_vm.installationJob.finance[props.item.type].warranty))]), _vm._v(" "), _c('li', [_vm._v("Warranty Type: " + _vm._s(_vm.installationJob.finance[props.item.type].warrantyType))]), _vm._v(" "), _c('li', [_vm._v("Upfront Amount: " + _vm._s(_vm.installationJob.finance[props.item.type].upfrontPayment))]), _vm._v(" "), _c('li', [_vm._v("Upfront Installation: " + _vm._s(_vm.installationJob.finance[props.item.type].installationPayment))]), _vm._v(" "), _c('li', [_vm._v("Rental Frequency: " + _vm._s(_vm.installationJob.finance[props.item.type].rentalFrequency))]), _vm._v(" "), _c('li', [_vm._v("Rental Amount: " + _vm._s(_vm.installationJob.finance[props.item.type].rentalPayment))]), _vm._v(" "), _c('li', [_vm._v("Lease Frequency: " + _vm._s(_vm.installationJob.finance[props.item.type].leaseFrequency))]), _vm._v(" "), _c('li', [_vm._v("Lease Amount: " + _vm._s(_vm.installationJob.finance[props.item.type].leasePayment))]), _vm._v(" "), _c('li', [_vm._v("Installation Date: " + _vm._s(_vm.installationJob.CompletedDate))]), _vm._v(" "), _c('li', [_vm._v("Project: " + _vm._s(_vm.installationJob.Project))]), _vm._v(" "), _c('li', [_vm._v("View Job: "), _c('v-btn', {
          attrs: {
            "small": "",
            "to": {
              path: ("/Project/" + (_vm.installationJob.Customer) + "/" + (_vm.installationJob.id))
            },
            "flat": ""
          }
        }, [_vm._v(_vm._s(_vm.installationJob.JobNo))])], 1), _vm._v(" "), _c('li', [_vm._v("View Product: "), _c('v-btn', {
          attrs: {
            "small": "",
            "to": {
              path: ("/Products/" + (_vm.installationJob.Customer) + "/" + (props.item.product) + "/" + (props.item.vehicle))
            },
            "flat": ""
          }
        }, [_vm._v("Go To Product")])], 1)])]) : (!_vm.loadingDeviceHistory) ? _c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-title', [_vm._v("No Installation Details Found")])], 1) : _c('v-card', {
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-title', [_vm._v("Loading...")])], 1)], 1)]
      }
    }], null, false, 2031936280)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: "calamp",
    attrs: {
      "value": "tab-calamp"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Bulk Paste",
      "color": "primary"
    },
    model: {
      value: (_vm.bulk),
      callback: function($$v) {
        _vm.bulk = $$v
      },
      expression: "bulk"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Use IMEI",
      "color": "primary"
    },
    model: {
      value: (_vm.useIMEI),
      callback: function($$v) {
        _vm.useIMEI = $$v
      },
      expression: "useIMEI"
    }
  })], 1)], 1), _vm._v(" "), (_vm.bulk) ? _c('v-textarea', {
    attrs: {
      "label": ("Bulk Paste " + (_vm.useIMEI ? 'IMEI' : 'ESN') + "'s Here")
    },
    on: {
      "keydown": function($event) {
        $event.preventDefault();
      },
      "input": _vm.updateESN
    },
    model: {
      value: (_vm.inputESN),
      callback: function($$v) {
        _vm.inputESN = $$v
      },
      expression: "inputESN"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.bulk) ? _c('v-combobox', {
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "label": ("Input " + (_vm.useIMEI ? 'IMEI' : 'ESN') + " and press enter"),
      "type": "number",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.ESNarray),
      callback: function($$v) {
        _vm.ESNarray = $$v
      },
      expression: "ESNarray"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.ESNarray.length
    },
    on: {
      "click": _vm.lookupCalamp
    }
  }, [_vm._v("\n          Lookup Calamps\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedEsns.length,
      "color": "secondary"
    },
    on: {
      "click": _vm.initUpdateDialog
    }
  }, [_vm._v("\n          Update Selected\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.selectedEsns.length
    },
    on: {
      "click": _vm.gotoBulkSMS
    }
  }, [_vm._v("\n          Populate Bulk SMS\n        ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.updateCalampDialog),
      callback: function($$v) {
        _vm.updateCalampDialog = $$v
      },
      expression: "updateCalampDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Update Selected Calamps")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Update Config"
    },
    model: {
      value: (_vm.updateCalampObj.updateConfig),
      callback: function($$v) {
        _vm.$set(_vm.updateCalampObj, "updateConfig", $$v)
      },
      expression: "updateCalampObj.updateConfig"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "disabled": !_vm.updateCalampObj.updateConfig,
      "items": _vm.calampConfigs,
      "label": "New Config",
      "item-text": "name",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(data.item.description))])], 1)]
        ]
      }
    }]),
    model: {
      value: (_vm.updateCalampObj.newConfig),
      callback: function($$v) {
        _vm.$set(_vm.updateCalampObj, "newConfig", $$v)
      },
      expression: "updateCalampObj.newConfig"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Update Group"
    },
    model: {
      value: (_vm.updateCalampObj.updateGroup),
      callback: function($$v) {
        _vm.$set(_vm.updateCalampObj, "updateGroup", $$v)
      },
      expression: "updateCalampObj.updateGroup"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "disabled": !_vm.updateCalampObj.updateGroup,
      "label": "New Group",
      "items": _vm.calampGroups,
      "item-text": "name",
      "item-value": "name",
      "return-object": ""
    },
    model: {
      value: (_vm.updateCalampObj.newGroup),
      callback: function($$v) {
        _vm.$set(_vm.updateCalampObj, "newGroup", $$v)
      },
      expression: "updateCalampObj.newGroup"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.updateCalampDialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success darken-1",
      "flat": "",
      "loading": _vm.updatingCalamps,
      "disabled": !_vm.updateCalampObj.updateGroup && !_vm.updateCalampObj.updateConfig
    },
    on: {
      "click": _vm.updateSelectedCalamps
    }
  }, [_vm._v("Save")])], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.calampHeaders,
      "items": _vm.filteredCalampTableDetails,
      "item-key": "esn",
      "select-all": "",
      "pagination": _vm.calampPagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.calampPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headerCell",
      fn: function(props) {
        return [_vm._v("\n            " + _vm._s(props.header.text) + "\n            "), _c('v-menu', {
          key: props.header.index,
          attrs: {
            "offset-y": "",
            "close-on-content-click": false
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": "",
                  "color": _vm.filters[props.header.index] && _vm.filters[props.header.index].length ? 'red' : ''
                }
              }, [_vm._v("\n                    mdi-filter-variant\n                ")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('div', {
          staticStyle: {
            "background-color": "white",
            "width": "280px"
          }
        }, [_c('v-list', [_c('v-list-tile', [_c('v-autocomplete', {
          attrs: {
            "multiple": "",
            "dense": "",
            "clearable": "",
            "chips": "",
            "small-chips": "",
            "color": "light-blue lighten-3",
            "items": _vm.columnValueList(props.header.value),
            "append-icon": "mdi-filter",
            "label": ("Filter By: " + (props.header.text)),
            "hide-details": ""
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function(ref) {
              var item = ref.item;
              var index = ref.index;

              return [(index < 5) ? _c('v-chip', {
                staticClass: "caption",
                attrs: {
                  "small": ""
                }
              }, [_c('span', [_vm._v("\n                            " + _vm._s(item) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (index === 5) ? _c('span', {
                staticClass: "grey--text caption"
              }, [_vm._v("\n                            (+" + _vm._s(_vm.filters[index].length - 5) + " others)\n                        ")]) : _vm._e()]
            }
          }], null, true),
          model: {
            value: (_vm.filters[props.header.index]),
            callback: function($$v) {
              _vm.$set(_vm.filters, props.header.index, $$v)
            },
            expression: "filters[props.header.index]"
          }
        })], 1)], 1)], 1)])]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "primary": "",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.esn))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.imei))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.group))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.configVersion))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.scriptVersion))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.configStatus))]), _vm._v(" "), _c('td', {
          on: {
            "click": function($event) {
              return _vm.expandCalampDetails(props)
            }
          }
        }, [_vm._v(_vm._s(props.item.configGroup))])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-card', [_c('v-sheet', {
          staticClass: "pa-3 primary lighten-2"
        }, [_c('v-text-field', {
          attrs: {
            "label": "Search Calamp Details",
            "dark": "",
            "flat": "",
            "solo-inverted": "",
            "hide-details": "",
            "clearable": "",
            "clear-icon": "mdi-close-circle-outline"
          },
          model: {
            value: (_vm.searchCalamp),
            callback: function($$v) {
              _vm.searchCalamp = $$v
            },
            expression: "searchCalamp"
          }
        })], 1), _vm._v(" "), _c('v-card-text', {
          staticStyle: {
            "overflow": "auto",
            "height": "300px"
          }
        }, [_c('v-treeview', {
          attrs: {
            "items": _vm.activeCalampDetails,
            "search": _vm.searchCalamp
          }
        })], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.selectedEsns),
      callback: function($$v) {
        _vm.selectedEsns = $$v
      },
      expression: "selectedEsns"
    }
  })], 1)], 1), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "exportData",
      "hidden": ""
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.testingDialog),
      callback: function($$v) {
        _vm.testingDialog = $$v
      },
      expression: "testingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('testing', {
    attrs: {
      "testID": _vm.testID,
      "testType": _vm.testType,
      "UID": _vm.testsUID
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "600px"
    },
    model: {
      value: (_vm.messagesDialog),
      callback: function($$v) {
        _vm.messagesDialog = $$v
      },
      expression: "messagesDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("The API returned the following messages")])]), _vm._v(" "), _c('v-card-text', [_c('v-list', [_vm._l((_vm.updateCalampErrorMessages), function(message, i) {
    return _c('ul', {
      key: i
    }, [_c('li', [_vm._v(_vm._s(message))])])
  }), _vm._v(" "), _vm._l((_vm.calampErrorMessages), function(message, i) {
    return _c('ul', {
      key: i
    }, [_c('li', [_vm._v(_vm._s(message))])])
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "grey darken-1",
      "flat": "flat"
    },
    on: {
      "click": function($event) {
        _vm.messagesDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Retrieving Data From Calamp\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aaa0e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Devices.vue
// module id = 739
// module chunks = 1